@if (sanitizedUrl) {
  <div class="w-full h-full mt-3">
    <iframe [src]="sanitizedUrl" height="800" width="100%"></iframe>
  </div>
}
